/** Pages that opted out of the shell with `Page.getLayout = (page) => page`. */
import { createFileRoute, Outlet } from '@tanstack/react-router'

import { AppErrorBoundary } from '@/components/app-error-boundary'

export const Route = createFileRoute('/_bare')({
  component: () => (
    <AppErrorBoundary>
      <Outlet />
    </AppErrorBoundary>
  ),
})
